import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { beam } from '@styles/colors/themes';
import { deviceTypes } from '@styles/mediaQueries';
import styled from 'styled-components';
import TextComponent, { TextType } from '@components/Text/Text';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 20px 24px 24px 24px;
  max-width: 900px;
  max-height: 700px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #fff;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  transform: scale(1);
  display: flex;
  flex-direction: column;

  [data-device='${deviceTypes.mobile}'] & {
    padding: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  [data-device='${deviceTypes.mobile}'] & {
    justify-content: start;
    column-gap: 12px;
  }
  height: 25px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;

  column-gap: 16px;

  [data-device='${deviceTypes.mobile}'] & {
    column-gap: 12px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;

  [data-device='${deviceTypes.mobile}'] & {
    flex-grow: 1;
    justify-content: space-between;
    column-gap: 12px;
  }
`;
export const HeaderRightButtons = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
  [data-device='${deviceTypes.mobile}'] & {
    column-gap: 12px;
  }
`;

interface ITextAndTabs {
  active?: string;
}

export const Text = styled.div<ITextAndTabs>`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;

  &.date {
    color: #696f8c;
    font-size: 14px;
    font-weight: 400;
  }

  &.small {
    color: #696f8c;
    font-size: 14px;
    font-weight: 400;
  }

  &.asset-count {
    font-size: 14px;
    font-weight: 500;
    color: #474d66;
  }

  &.tabs-d {
    font-size: 14px;
    font-weight: ${({ active }) => {
      if (active === 'Description') {
        return 500;
      }
      return 400;
    }};
    color: ${({ active }) => {
      if (active === 'Description') {
        return '#1b203a';
      }
      return '#696f8c';
    }};
  }

  &.tabs-un {
    font-size: 14px;
    font-weight: ${({ active }) => {
      if (active === 'Update Notes') {
        return 500;
      }
      return 400;
    }};
    color: ${({ active }) => {
      if (active === 'Update Notes') {
        return '#1b203a';
      }
      return '#696f8c';
    }};
  }

  &.tabs-rn {
    font-size: 14px;
    font-weight: ${({ active }) => {
      if (active === 'Related Notes') {
        return 500;
      }
      return 400;
    }};
    color: ${({ active }) => {
      if (active === 'Related Notes') {
        return '#1b203a';
      }
      return '#696f8c';
    }};
  }
`;

export const Subject = styled.div<ITextAndTabs>`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Close = styled.div`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;
  padding-top: 5px;
  z-index: 2;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const BackIcon = styled.img`
  cursor: pointer;
`;

export const Line = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
`;

interface IConfirm {
  disabled?: boolean;
}

export const Confirm = styled.button<IConfirm>`
  display: flex;
  height: 36px;
  padding: 0 16px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #d8dae5;
  align-items: center;
  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  &.header {
    margin-bottom: 24px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  display: flex;
  width: 331px;
  height: 36px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  font-size: 12px;

  color: ${({ isLink }) => (isLink ? beam.color.primaryBlue : '#474d66')};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};

  transition: all 0.2s;

  margin-top: 8px;

  ::placeholder {
    color: #8f95b2;
  }
  &.infoInputs {
    width: 100%;
  }
`;
export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const FileName = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: #474d66;
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

export const ProfileImg = styled.img`
  width: 62px;
  height: 62px;
  border-radius: 32px;

  margin-right: 24px;
  object-fit: cover;
`;

export const Form = styled.form`
  width: 100%;
`;

export const SubjectDivider = styled.div`
  width: 100%;
  margin-top: 16px;
  border-bottom: 1px solid #e6e8f0;

  margin-bottom: 16px;

  [data-device='${deviceTypes.mobile}'] & {
    margin-bottom: 0;
    border: none;
  }
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;

export const Description = styled.div`
  font-weight: 400;
  color: #474d66;
  font-size: 14px;
  margin-bottom: 24px;
`;

export const Error = styled.div`
  color: #ea1212;
  font-size: 12px;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const QuickActionsIcons = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

export const Table = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 40px;
`;

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Head = styled.div`
  background: #fff;
  padding-top: 7px;
  padding-bottom: 7px;
  color: #8f95b2;
  font-size: 12px;
  font-weight: 400;

  &.member {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    padding-left: 7px;
  }

  &.center {
    padding-left: 7px;
  }

  &.menu {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

export const Tag1 = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  background-color: #e7e4f9;
  border-radius: 15px;
  padding: 4px 12px 4px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #524988;
  margin-right: 8px;
`;

export const Tag2 = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  background-color: #e6edff;
  border-radius: 15px;
  padding: 4px 12px 4px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #1f3d99;
`;

export const AssetImg = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
  background: transparent;
  &.defaultImage {
    border: none;
  }
`;

export const AssetImgContainer = styled.div``;

export const AssetName = styled.div`
  color: #1b203a;
  font-size: 14px;
  font-weight: 500;
`;

export const QuickActionsDiv = styled.button`
  display: flex;
  flex-direction: row;
  border: 0;
  border-radius: 8px;
  background-color: transparent;
  align-items: center;
  padding: 5px 7px;
  transition: 0.2s;

  column-gap: 8px;

  :enabled:hover {
    background-color: #f6f8ff;
  }
  :disabled {
    cursor: not-allowed;
  }

  [data-device='${deviceTypes.mobile}'] & {
    padding: 7px 7px;
  }
`;

export const TagsDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-height: 30px;
  position: relative;

  margin-top: 16px;
  margin-bottom: 16px;
  column-gap: 16px;

  [data-device='${deviceTypes.mobile}'] & {
    margin-top: 8px;
    column-gap: 4px;
  }
`;

export const TagsRight = styled.div`
  width: 90%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 74%, #fff 97%);
`;

export const AssetsCountSquare = styled.div`
  display: flex;
  flex-direction: row;
  max-height: 30px;
  background-color: #edeff4;
  border-radius: 4px;
  padding: 4px 6px 4px 6px;
  align-items: center;
  cursor: pointer;

  column-gap: 8px;

  [data-device='${deviceTypes.mobile}'] & {
    cursor: default;
  }
`;

export const TagsContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;

  column-gap: 8px;

  [data-device='${deviceTypes.mobile}'] & {
    column-gap: 4px;
  }
`;

interface ITags {
  background?: string;
  color?: string;
}

export const Tags = styled.div<ITags>`
  display: flex;
  align-items: center;
  height: 30px;
  width: fit-content;
  border-radius: 15px;
  padding: 4px 12px 4px 12px;
  background: ${({ background }) => background || '#edeff4'};
  color: ${({ color }) => color || '#474d66'};
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;

  & + & {
    margin-left: 8px;
  }
`;

interface IWidthDivider {
  width: string;
}

export const WidthDivider = styled.div<IWidthDivider>`
  width: ${({ width }) => width};
`;

export const TabsContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;

  column-gap: 32px;

  [data-device='${deviceTypes.mobile}'] & {
    column-gap: 16px;
  }
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
}

export const Indicator = styled.div<isActiveProps>`
  height: 2px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: ${({ isActive }) => (isActive ? '#1371fe' : 'transparent')};
  z-index: 2;
`;

export const Back = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #edeff4;
  z-index: 1;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const Label = styled.div`
  padding-right: 6px;
  padding-left: 6px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

export const LabelText = styled.div<isActiveProps>`
  white-space: nowrap;
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#696F8C')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};

  &.tabs-text {
    font-size: 14px;
    font-weight: 500;
    color: #1b203a;
  }

  [data-device='${deviceTypes.mobile}'] & {
    &.tabs-text {
      line-height: 1.5;
      font-size: 12px;
    }
  }
`;

interface IBody {
  show: boolean;
}

export const Body = styled.div<IBody>`
  display: ${({ show }) => (show ? 'block' : 'none')};

  background: #fff;
`;

export const Internal = styled.div`
  color: #1371fe;
  font-weight: 500;
`;

export const ManufacturerText = styled(TextComponent)`
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;
` as TextType;

export const Assignee = styled.img`
  height: 24px;
  width: 24px;
  object-fit: cover;
  border-radius: 12px;

  [data-device='${deviceTypes.mobile}'] & {
    width: 16px;
    height: 16px;
  }
`;

export const IconContainer = styled.div`
  height: 16px;
  width: 16px;
  overflow: hidden;
`;

export const IconContainerUncertain = styled.div`
  margin-right: 8px;
`;

export const Icon = styled.div`
  height: 20px;
  /* margin-right: 8px; */
`;

export const Icon2 = styled.div`
  height: 24px;
  margin-right: 8px;
`;

export const LoadingFilter = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 8px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
`;
